import Icon from '@ant-design/icons';

const TextColor = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.49974 14H2L6.55129 2H9.4424L14 14H11.5003L8.04734 4.46094H7.94634L4.49974 14ZM4.5818 9.29492H11.3993V11.041H4.5818V9.29492Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TextColorIcon = (props: any) => <Icon component={TextColor} {...props} />;
